import type { ReactNode } from 'react';
import { ChatContentLayout } from '../chat-content-layout';
import { ChatroomSidebar, ChatroomSidebarContent } from '../chatroom-sidebar';
import type { ChatroomsSearchParamsOptions } from '../types';

type P = {
  children: ReactNode;
  onChatDeleted: () => Promise<void>;
  onChatRoomClicked: (id: string) => Promise<void>;
  onCreateChatClicked: () => Promise<void>;
  searchParamsOptions: ChatroomsSearchParamsOptions;
  selectedChatroomId?: string;
};

const ChatCreateLayout = ({
  children,
  onChatDeleted,
  onChatRoomClicked,
  onCreateChatClicked,
  searchParamsOptions,
  selectedChatroomId,
}: P) => (
  <ChatContentLayout
    left={
      <ChatroomSidebar onCreateChatClicked={onCreateChatClicked} searchParamsOptions={searchParamsOptions}>
        {({ filter }) => (
          <ChatroomSidebarContent
            filter={filter}
            onChatDeleted={onChatDeleted}
            onChatRoomClicked={onChatRoomClicked}
            onCreateChatClicked={onCreateChatClicked}
            selectedChatroomId={selectedChatroomId}
          />
        )}
      </ChatroomSidebar>
    }
    right={children}
  />
);

export default ChatCreateLayout;
